import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { Service, ServiceResponse } from '@/features/services/types';

type UseServiceOptions = {
  businessId?: number;
  page?: number;
  perPage?: number;
};
export const getServices = ({ businessId, page, perPage }: UseServiceOptions = {}): Promise<
ServiceResponse
> => {
  return axios.get(`/services/all`, {
    params: { page, perPage },
  });
};

type QueryFnType = typeof getServices;

export const useServices = ({ businessId,page,perPage }: UseServiceOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['services_availability'],
    queryFn: () => getServices({ businessId,page,perPage }),
  });
};
